var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.producer.onlineResource != null
    ? _c("div", { staticClass: "ui segment" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm.producer.onlineResource.urlInfo != null
          ? _c("div", [
              _c("b", [_vm._v("Website")]),
              _vm._v(" : "),
              _c(
                "a",
                {
                  attrs: {
                    href: _vm.getI18n(_vm.producer.onlineResource.urlInfo, "en")
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.getI18n(_vm.producer.onlineResource.urlInfo, "en")
                    )
                  )
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.producer.onlineResource.urlDownload != null
          ? _c("div", [
              _c("b", [_vm._v("Data portal")]),
              _vm._v(" : "),
              _c(
                "a",
                {
                  attrs: {
                    href: _vm.getI18n(
                      _vm.producer.onlineResource.urlDownload,
                      "en"
                    )
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.getI18n(_vm.producer.onlineResource.urlDownload, "en")
                    )
                  )
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.producer.onlineResource.doi
          ? _c("div", [
              _vm._v("DOI : "),
              _c(
                "a",
                {
                  attrs: {
                    href: "http://dx.doi.org/" + _vm.producer.onlineResource.doi
                  }
                },
                [_vm._v(_vm._s(_vm.producer.onlineResource.doi))]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.producer.onlineResource.webservices != null
          ? _c(
              "div",
              { staticClass: "ui segment" },
              [
                _c("div", { staticClass: "ui top left attached label" }, [
                  _vm._v("Webservices:")
                ]),
                _vm._v(" "),
                _vm._l(_vm.producer.onlineResource.webservices, function(
                  webservice,
                  index
                ) {
                  return _c("div", { key: index }, [
                    _c("div", { staticClass: "ui segment" }, [
                      _c("div", [
                        _vm._v(
                          "Description : " +
                            _vm._s(_vm.getI18n(webservice.description, "en"))
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v("Url : "),
                        _c(
                          "a",
                          {
                            attrs: { href: _vm.getI18n(webservice.url, "en") }
                          },
                          [_vm._v(_vm._s(_vm.getI18n(webservice.url, "en")))]
                        )
                      ])
                    ])
                  ])
                })
              ],
              2
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui top attached label" }, [
      _c("i", { staticClass: "cloud icon" }),
      _vm._v(" Online resources:")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }